export default __webpack_public_path__ + "static/cafe_36001-c1fd3a4bfec833ae48dd79cfc72ad60d.png";